module.exports = __webpack_public_path__ + "img/runing.e4f00f8d.png";